import {
  AUTHENTICATING_ZOOM_REQUEST,
  UPDATING_ZOOM_REQUEST, UPDATING_ZOOM_SUCCEDDED, UPDATING_ZOOM_FAILED,
} from '../../actions/actionTypes.jsx';

const initialState = {
changes: {
  saving: false,
  error: null
},
authentication: {
  authenticating: false,
  error: null
}
};

function zoomReducer(state = initialState, action) {
switch (action.type) {
  case AUTHENTICATING_ZOOM_REQUEST:
    return Object.assign({}, state, {
      ...state,
      authentication: {
        authenticating: true,
        error: null
      }
    })
  // case AUTHENTICATING_ZOOM_SUCCEDDED:
  //   return Object.assign({}, state, {
  //     ...state,
  //     authentication: {
  //       authenticating: false,
  //       error: null
  //     }
  //   })
  // case AUTHENTICATING_ZOOM_FAILED:
  //   return Object.assign({}, state, {
  //     ...state,
  //     authentication: {
  //       authenticating: false,
  //       error: action.payload
  //     }
  //   }) 
  case UPDATING_ZOOM_REQUEST:
    return Object.assign({}, state, {
      ...state,
      changes: {
        saving: true,
        error: null
      }
    })
  case UPDATING_ZOOM_SUCCEDDED:
    return Object.assign({}, state, {
      ...state,
      changes: {
        saving: false,
        error: null
      }
    })
  case UPDATING_ZOOM_FAILED:
    return Object.assign({}, state, {
      ...state,
      changes: {
        saving: false,
        error: action.payload
      }
    })
  default:
    return state;
}
}

export { zoomReducer };